import React from "react";

export default function Youtube({ className }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="39.893"
      height="40.424"
      viewBox="0 0 39.893 40.424"
      className={className}
    >
      <path
        id="Path_298"
        data-name="Path 298"
        d="M1219.988,8218a20.213,20.213,0,1,1-.7,40.42c-10.9-.154-19.474-9.462-19.3-20.945A20.116,20.116,0,0,1,1219.988,8218Zm-.172,27.852c2.031,0,4.054.028,6.076-.008a4.668,4.668,0,0,0,4.758-4.839c.027-1.788.018-3.577,0-5.364-.027-2.88-1.751-4.929-4.586-5.019-4.09-.145-8.189-.137-12.279-.011-2.826.082-4.587,2.113-4.623,4.985q-.027,2.681,0,5.361a4.683,4.683,0,0,0,4.839,4.886c1.941.026,3.873.008,5.814.008Z"
        transform="translate(-1199.987 -8217.998)"
        fill="currentColor"
      />
      <path
        id="Path_299"
        data-name="Path 299"
        d="M1225.748,8240.309c-2.076,1.039-3.783,1.914-5.507,2.745-.677.324-1.11.071-1.11-.731,0-1.472-.009-2.935.009-4.4.009-.759.469-.957,1.056-.65,1.743.913,3.449,1.879,5.552,3.034Z"
        transform="translate(-1201.847 -8219.857)"
        fill="currentColor"
      />
    </svg>
  );
}
